module.exports = __webpack_public_path__ + "static/work-6c712bf62e10f53bb32f1530a2d11f1e.jpg";